
import { format, subDays } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { getLanguage } from './languageUtils';

/**
 * Gets the thirty days ago date
 */
export function getThirtyDaysAgo(): Date {
  const date = new Date();
  date.setDate(date.getDate() - 30);
  return date;
}

export function getDaysAgo(days: number): Date {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
}

/**
 * Format date based on current language
 */
export function formatDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const language = getLanguage();
    return format(date, 'dd MMM yyyy', {
      locale: language === 'pl' ? pl : enUS,
    });
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString;
  }
}
